import { Variant } from './products';

export type QuoteAddress = {
  address?: string;
  postalCode?: string;
  postalAddress?: string;
};

export enum QuoteStatus {
  notSent = 'notSent',
  draft = 'draft',
  inReview = 'inReview',
  sent = 'sent',
  accepted = 'accepted',
  completed = 'completed',
  declined = 'declined',
}

export type QuoteProduct = {
  quoteItemId: number;
  articleNumber: string;
  quantity: number;
  markup?: number;
  salesDiscount?: number;
  netPrice: number;
  salesPrice: number;
  quoteNetPrice: number;
  quoteSalesPrice: number;
  articleName?: string;
};

export type QuoteVariant = QuoteProduct &
  Variant & {
    isSelected: boolean; // Only for frontend, handles the checkbox select
    isExpanded?: boolean;
    isEdit?: boolean;
    discontinued?: boolean;
  };

export type QuoteCustomItem = {
  isEdit?: boolean;
  quoteCustomItemId: number;
  isSelected: boolean;
  customItemName?: string;
  quantity?: number;
  unit?: string;
  vatRate?: number;
  price?: number;
  isRot: boolean;
};

export type Quote = {
  quoteId?: number;
  status: QuoteStatus;
  sender: {
    name?: string;
    organizationNumber?: string;
    reference?: string;
    address: QuoteAddress;
  };
  receiver: {
    type: string;
    label?: string;
    name?: string;
    contactPerson?: string;
    address: QuoteAddress;
  };
  priceType: string;
  mergeArticles: boolean;
  showDiscounts: boolean;
  items: QuoteProduct[];
  customItems: QuoteCustomItem[];
  finalMessage?: string;
  validFrom?: string;
  validFor?: number;
};

export type QuoteDefaultValues = {
  sender: {
    name?: string;
    organizationNumber?: string;
    reference?: string;
    address?: QuoteAddress;
  };
};

export type QuoteResponseEntity = Quote & {
  updatedAt: Date;
  createdAt: Date;
  itemsCount: number;
  netPriceSum?: number;
  salesPriceSum?: number;
  quotePriceSum?: number;
};

export type AddToQuoteLayout = 'simple' | 'extended' | 'fayt';

export type QuoteListItem = {
  isSelected: boolean; // Only for frontend, handles the checkbox select
  id: number;
  status: QuoteStatus;
  productCount: number;
  productSum: number;
  quoteProductSum: number;
  updatedAt: Date;
  receiverLabel?: string;
  contactPerson?: string;
};

export type QuoteListSortByValue = 'quoteId' | 'updatedAt' | 'customerName';

export type QuoteListQueryParams = {
  offset: number;
  limit: number;
  sortBy?: QuoteListSortByValue;
  sortOrder?: 'asc' | 'desc';
  search?: string;
  startDate?: string;
  endDate?: string;
  status?: 'draft' | 'accepted';
};

export type ButtonConfig = {
  id: string;
  label: string;
  testId?: string;
  variant: 'secondary' | 'primary' | 'green';
  icon?: string;
  action?: () => void | Promise<any>;
  group: 'status' | 'secondary';
};

type ActionPlacement = 'standalone' | 'menu-status' | 'menu-secondary' | 'last' | 'hidden';

export type ActionRegistryItem = {
  id: string;
  group: 'status' | 'secondary';
  text: string;
  variant: 'secondary' | 'primary' | 'green';
  icon?: string;
  testId?: string;
  action?: () => void | Promise<void>;
  status: Partial<Record<QuoteStatus, ActionPlacement>>;
};

export type ResolvedAction = ButtonConfig & { placement: ActionPlacement };
